import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import './DashboardLayout.css';
import { useDispatch, useSelector } from 'react-redux';  
import { useNavigate, useLocation } from 'react-router-dom'; 
import Header from './Header';
import { Box } from '@mui/material';

const DashboardLayout = ({ children }) => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  }; 

  const { user } = useSelector(state => state.auth);
  return (
    <div className="dashboard-layout">
      {/* <div className="top-bar">
        <Grid container spacing={2}>
          <Grid item size={{ xs: 6, md: 8, lg: 6, xxl: 6 }} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <img src={logo} alt="Logo" style={{ maxWidth: "110px" }} />
            {sidebarOpen ? <MenuIcon onClick={toggleSidebar} sx={{ cursor: "pointer" }} /> : <MenuOpenIcon onClick={toggleSidebar} sx={{ cursor: "pointer" }} />}


          </Grid>
          <Grid item size={{ xs: 6, md: 8, lg: 6, xxl: 6 }} sx={{ textAlign: "right" }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
              <Tooltip title="Account settings" style={{ display: 'flex', alignItems: 'center', marginRight: 3 }}>
                <IconButton
                  size="small"
                  sx={{ mr: 2, bgcolor: "var(--primary-color)", color: '#fff', width: 32, height: 32 }}
                  aria-controls={open ? 'account-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                >
                  ?
                </IconButton>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", marginRight: 2 }}>
                  <Typography variant="body1" component="div" sx={{ fontWeight: 'bold', fontSize: '0.88rem' }}>
                    Need Help
                  </Typography>
                  <Typography variant="h6" component="div" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
                    Contact Support
                  </Typography>
                </Box>
              </Tooltip>
              <Box sx={{ display: "flex", alignItems: "flex-end", marginRight: 0 }} onClick={handleClick}>
                <div>
                  <Typography variant="body1" component="div" sx={{ fontWeight: 'bold', fontSize: '0.88rem' }}>
                    Hi, {user?.username || 'User'}
                  </Typography>
                  <Typography variant="h6" component="div" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
                    {user?.role || 'Employee'}
                  </Typography>
                </div>
                <Tooltip title="Account settings" style={{ display: 'flex', alignItems: 'center', }}>
                  <IconButton

                    size="small"
                    sx={{ ml: 1 }}
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                  >
                    <Avatar sx={{ width: 32, height: 32 }}>{user?.username?.charAt(0).toUpperCase() || 'U'}</Avatar>
                  </IconButton>
                  <KeyboardArrowDownIcon />
                </Tooltip>
              </Box>
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                // onClick={handleClose}
                slotProps={{
                  paper: {
                    elevation: 0,
                    sx: {
                      overflow: 'visible',
                      filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                      mt: 1.5,
                      '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      '&::before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                      },
                    },
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem>
                  {user?.username || 'User'}
                </MenuItem>
                <MenuItem>
                  <ListItemIcon>

                  </ListItemIcon>Switch Role
                </MenuItem>
                <MenuItem onClick={handleLogout} className="logout-btn">
                  <ListItemIcon >
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </Menu>
            </Box>

          </Grid>
        </Grid>
      </div> */}
      <Header sidebarOpen={sidebarOpen} onToggleSidebar={toggleSidebar} />
      <div className={`main-content ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <Sidebar isOpen={sidebarOpen} />
        <Box className="content-wrapper" sx={{ mt: 1.5, mr: 1.5, mb: 1.5, marginLeft: sidebarOpen ? '235px' : '15px', transition: 'margin-left 0.3s ease', p: 2.5, }}>
          {children || <Outlet />}
        </Box>
      </div>
    </div>
  );
};

export default DashboardLayout;
